import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';

const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return String(value);
  return parsed.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
};

const formatNumberFixed2 = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return String(value);
  return parsed.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatInteger = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return String(value);
  return parsed.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
};

const SituacaoBadge = ({ value }) => {
  const normalized = (value || '').toString().toUpperCase();
  const color = normalized === 'ATIVO' ? 'success' : normalized === 'INATIVO' ? 'neutral' : 'warning';
  const label = normalized || '-';
  return <TableBadge color={color} label={label} />;
};

const toStr = (value) => (value === null || value === undefined ? '' : String(value));

export const getModelosVeicularesColumns = () => [
  {
    id: 'descricao',
    header: 'Descricao',
    accessorKey: 'descricao',
    size: 220,
    enableSorting: true,
    cell: ({ getValue }) => {
      const val = toStr(getValue());
      return (
        <Tooltip dir="top" text={val}>
          <div style={{ cursor: 'pointer' }}>
            <TruncatedText value={val} maxLength={28} />
          </div>
        </Tooltip>
      );
    },
  },
  {
    id: 'nomeTipoModeloVeicular',
    header: 'Tipo de Modelo',
    accessorKey: 'nomeTipoModeloVeicular',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={20} />,
  },
  {
    id: 'unidadeCapacidade',
    header: 'Unid. Capacidade',
    accessorKey: 'unidadeCapacidade',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={10} />,
  },
  {
    id: 'capacidadeModelo',
    header: 'Capacidade',
    accessorKey: 'capacidadeModelo',
    size: 120,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumber(getValue())}</span>,
  },
  {
    id: 'numeroEixos',
    header: 'Eixos',
    accessorKey: 'numeroEixos',
    size: 90,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatInteger(getValue())}</span>,
  },
  {
    id: 'ocupacaoCubicaPallets',
    header: 'Ocup. Cubica (pallets)',
    accessorKey: 'ocupacaoCubicaPallets',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumberFixed2(getValue())}</span>,
  },
  {
    id: 'ocupacaoCubicaMaxima',
    header: 'Ocup. Cubica Max.',
    accessorKey: 'ocupacaoCubicaMaxima',
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumberFixed2(getValue())}</span>,
  },
  {
    id: 'quantidadePallet',
    header: 'Qtd. Pallet',
    accessorKey: 'quantidadePallet',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumberFixed2(getValue())}</span>,
  },
  {
    id: 'capacidadeMaximoPallets',
    header: 'Cap. Max. Pallets',
    accessorKey: 'capacidadeMaximoPallets',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumberFixed2(getValue())}</span>,
  },
  {
    id: 'toleranciaMinimaCarregamento',
    header: 'Tol. Min. Carreg.',
    accessorKey: 'toleranciaMinimaCarregamento',
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumberFixed2(getValue())}</span>,
  },
  {
    id: 'codigoIntegracao',
    header: 'Cod. Integracao',
    accessorKey: 'codigoIntegracao',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => {
      const val = toStr(getValue());
      return (
        <Tooltip dir="top" text={val}>
          <div style={{ cursor: 'pointer' }}>
            <TruncatedText value={val} maxLength={18} />
          </div>
        </Tooltip>
      );
    },
  },
  {
    id: 'situacao',
    header: 'Situacao',
    accessorKey: 'situacao',
    size: 110,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();
      const label = value === 1 || value === 'ATIVO' ? 'Ativo' : value === 0 || value === 'INATIVO' ? 'Inativo' : value;
      return <SituacaoBadge value={label} />;
    },
  },
];

